// ModelViewer.jsx
import '@google/model-viewer';
import { useRef, useState, useEffect } from "react";
import useIsMobile from "../hooks/useIsMobile";
import StartAudio from '../images/icons/image-card-icons/card-icon-start.svg'
import StopAudio from '../images/icons/image-card-icons/card-icon-stop.svg'
import SoundWave from '../images/audio-wave.svg'
import cardAdd from '../images/icons/image-card-icons/card-icon-add-to-collection.svg';
import cardInCollection from '../images/icons/image-card-icons/card-icon-add-to-collection-active.svg';
import cardRemove from '../images/icons/image-card-icons/card-icon-remove.svg';
import cardCopy from '../images/icons/image-card-icons/card-icon-copy-image.svg';
import cardCopyDescription from '../images/icons/image-card-icons/card-icon-copy-description.svg';
import cardSave from '../images/icons/image-card-icons/card-icon-save-image.svg';
import cardSaveDescription  from '../images/icons/image-card-icons/card-icon-save-description.svg';
import cardPopulatePrompt from '../images/icons/image-card-icons/card-icon-populate-prompt.svg';
import cardZoom from '../images/icons/image-card-icons/card-icon-zoom-in.svg';
import { ReactComponent as CardShare } from '../images/icons/image-card-icons/card-icon-share-to-community.svg';
import cardTag from '../images/icons/image-card-icons/card-icon-tag.svg';
import cardPublic  from '../images/icons/image-card-icons/card-icon-public.svg';
import cardPrivate  from '../images/icons/image-card-icons/card-icon-private.svg';
import cardEye from '../images/icons/image-card-icons/card-icon-eye.svg';
import cardImageDescribe from '../images/icons/image-card-icons/card-icon-describe-image.svg';
import cardEdit from '../images/icons/image-card-icons/card-icon-edit.svg'
import { ReactComponent as CardEye } from '../images/icons/image-card-icons/card-icon-eye.svg';
import closeIcon from "../images/icons/white-close.svg";
import uploadIconWhite from "../images/icons/input-bar-icons/icon-input-bar-upload-white.svg";
import { db } from "../db";
import { useDriverContextDispatch } from "../context/DriverContext";
import { useCollectionContext, useCollectionContextDispatch } from "../context/CollectionContext";
import { useAccountContext } from "../context/AccountContext";
import { usePromptusAPIState } from "../context/PromptusAPIContext";
import Swal from "sweetalert2";
import CollectSound from "../sounds/collect.flac";
import { getImageMetadata, updateAccount, deleteCollectionImage, getImageDescription, changeImageVisibility, updateImageTags, getAuthorizationToken, getUseDepApi, getPromptFileData, getGenerateOutput } from "../api-helper";
import { useNavigate } from "react-router-dom";
import { Modal } from 'react-responsive-modal';
import { copyDescriptionToClipboard, downloadDescriptionAsPromptFile, populatePromptField } from './ImageDescriptionUtils';
import { usePromptContext } from "../context/PromptContext";
import Select, {InputAction} from 'react-select';
import ToggleInput from "./inputs/ToggleInput";
import makeAnimated from 'react-select/animated'
import { isUndefined } from "cropperjs";
import electronBridge from '../utils/electronBridge';
import { ReactComponent as CardSave } from '../images/icons/image-card-icons/card-icon-save-image.svg';
import { fetchMediaType } from "../utils/MediaOperations";

const animatedComponents = makeAnimated()

export async function downloadString(text, fileType, fileName) {
    const blob = new Blob([text], { type: fileType });
    const ext = fileName.split('.').pop();

    if (window.showSaveFilePicker && !electronBridge.isElectron) {
        try {
            const handle = await window.showSaveFilePicker({
                suggestedName: fileName,
                types: [{ description: `${ext.toUpperCase()} File`, accept: { [fileType]: [`.${ext}`] } }]
            });
            const writable = await handle.createWritable();
            await writable.write(blob);
            await writable.close();
            return;
        } catch (err) {
            if (err.name === 'AbortError') return;
            console.warn('showSaveFilePicker failed, falling back:', err);
        }
    }

    const a = document.createElement('a');
    a.download = fileName;
    a.href = URL.createObjectURL(blob);
    a.dataset.downloadurl = [fileType, a.download, a.href].join(':');
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function() { URL.revokeObjectURL(a.href); }, 1500);
}

export default function ModelCanvas(props) {
    const videoRef = useRef(null);
    const [showVideoControls, setShowVideoControls] = useState(false);
    const [showMobileToolbar, setShowMobileToolbar] = useState(false);
    const [enableAutoSound, setEnableAutoSound] = useState(false);
    const isMobile = useIsMobile();
    const toolbarRef = useRef(null);
    const menuButtonRef = useRef(null);

    const [localInCollection, setLocalInCollection] = useState(props.inCollection);
    const [privateImage, setPrivateImage] = useState(true);
    const [visibility, setVisibility] = useState("");
    const navigate = useNavigate();
    const [promptInfo, setPromptInfo] = useState({});
    const [openDescribeImage, setOpenDescribeImage] = useState(false);
    const [clipboardMessage, setClipboardMessage] = useState('');    
    const [imageDescriptionLoading, setImageDescriptionLoading] = useState(false);
    const [imageDescription, setImageDescription] = useState("");
    const [downloadName, setDownloadName] = useState(`Promptus_${props.uid}`)
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]); 
    const [tag, setTag] = useState("");
    const [clearTags, setClearTags] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [inputTag, setInputTag] = useState("");
    const [tagLoading, setTagLoading] = useState(false);
    const [showSaveDialog, setShowSaveDialog] = useState(false);
    const [showShareDialog, setShowShareDialog] = useState(false);
    const [localModelOverride, setLocalModelOverride] = useState(null);

    const driverContextDispatch = useDriverContextDispatch();
    const collectionContextDispatch = useCollectionContextDispatch();
    const collectionContext = useCollectionContext();
    const accountContext = useAccountContext();
    const apiState = usePromptusAPIState();
    const { updatePrompt } = usePromptContext();
    
    const toFileUrl = (filePath) => {
        return filePath;
      }

    useEffect(() => {
      setPromptInfo({prompt: props.prompt})
      if (props.public && props.public == "1") {
        setVisibility("Public");
        setPrivateImage(false);
    } else {
        setVisibility("Private")
        setPrivateImage(true);
    }

      if (props.tag) {
        setTag(props.tag);
      }
    },[])

    useEffect(() => {
        const convertBase64ToUrl = async () => {
            if (electronBridge.isElectron) {
                return;
            }

            const isModelUrl = props.image && (props.image.startsWith('http://') || props.image.startsWith('https://'));

            if (!isModelUrl && props.uid && props.hash && props.image) {
                try {
                    console.log('[3DModel] Base64 model detected, fetching URL from API...');
                    const result = await getGenerateOutput(props.uid, props.hash);
                    console.log('[3DModel] Response from API:', result);

                    if (result.url && result.url.trim() !== '') {
                        console.log('[3DModel] Successfully retrieved URL from API:', result.url);

                        await db.images.where('hash').equals(props.hash).modify({ image: result.url });
                        await db.collectedImages.where('hash').equals(props.hash).modify({ image: result.url });

                        setLocalModelOverride(result.url);
                    }
                } catch (error) {
                    console.error('[3DModel] Error fetching URL from API:', error);
                }
            }
        };

        convertBase64ToUrl();
    }, [props.image, props.uid, props.hash]);

    // Load enable_auto_sound setting
    useEffect(() => {
        const loadAutoSoundSetting = async () => {
            try {
                const setting = await db.settings.where('key').equals('enable_auto_sound').first();
                if (setting) {
                    setEnableAutoSound(setting.value);
                } else {
                    // Default to false if setting doesn't exist
                    setEnableAutoSound(false);
                }
            } catch (error) {
                console.error('Error loading auto sound setting:', error);
                setEnableAutoSound(false);
            }
        };

        loadAutoSoundSetting();
    }, []);

    // Handle click outside for mobile toolbar
    useEffect(() => {
        if (!isMobile) return;

        const handleClickOutside = (event) => {
            if (
                toolbarRef.current && 
                !toolbarRef.current.contains(event.target) &&
                menuButtonRef.current &&
                !menuButtonRef.current.contains(event.target)
            ) {
                setShowMobileToolbar(false);
            }
        };

        if (showMobileToolbar) {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('touchstart', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [showMobileToolbar, isMobile]);

    useEffect(() => {
        if (!props.image || props.image === '' || !props.id) return;

        (async () => {
            try {
                const detectedType = await fetchMediaType(props.image);
                const normalizedType = detectedType?.toLowerCase() || '3d';
                const currentDataType = props.dataType?.toLowerCase() || '3d';

                if (normalizedType !== currentDataType && ['image', 'video', 'audio'].includes(normalizedType)) {
                    console.log(`[MEDIA_MATCH_CHECK] DataType mismatch detected for id ${props.id}: stored="${currentDataType}", actual="${normalizedType}". Updating...`);
                    await db.images.update(props.id, { dataType: normalizedType });
                    props.refreshImages?.();
                }
            } catch (err) {
                console.error("[MEDIA_MATCH_CHECK] Error detecting media type:", err);
            }
        })();
    }, [props.image, props.id, props.dataType]);

    async function getMediaType(base64String, returnExtension = false) {
        try {
            const cleaned = base64String.trim().replace(/\s/g, '');
            const padded = cleaned + '==='.slice((cleaned.length + 3) % 4);
            const binaryStr = atob(padded);
            const bytes = new Uint8Array(binaryStr.length);

            for (let i = 0; i < binaryStr.length; i++) {
                bytes[i] = binaryStr.charCodeAt(i);
            }

            // Generate hex string from first 64 bytes for better detection
            const hex = Array.from(bytes.slice(0, 64))
                .map(b => b.toString(16).padStart(2, '0'))
                .join('');

            console.log('First 64 bytes hex:', hex);

            // Helper to check ASCII string at offset
            const asciiAt = (offset, str) => {
                if (offset + str.length > bytes.length) return false;
                for (let i = 0; i < str.length; i++) {
                    if (bytes[offset + i] !== str.charCodeAt(i)) return false;
                }
                return true;
            };

            // RIFF-based formats need special handling (WAV, WEBP, AVI all start with RIFF)
            if (hex.startsWith('52494646') && bytes.length >= 12) {
                if (asciiAt(8, 'WAVE')) return returnExtension ? 'wav' : "Audio";
                if (asciiAt(8, 'WEBP')) return returnExtension ? 'webp' : "Image";
                if (asciiAt(8, 'AVI ')) return returnExtension ? 'avi' : "Video";
            }

            // MP3: ID3 tag or frame sync
            if (asciiAt(0, 'ID3') || (bytes[0] === 0xFF && (bytes[1] & 0xE0) === 0xE0)) {
                return returnExtension ? 'mp3' : "Audio";
            }

            // FLAC: starts with "fLaC"
            if (asciiAt(0, 'fLaC')) {
                return returnExtension ? 'flac' : "Audio";
            }

            // M4A/MP4: ftyp with brands
            if (bytes.length >= 12 && bytes[4] === 0x66 && bytes[5] === 0x74 && bytes[6] === 0x79 && bytes[7] === 0x70) {
                const brand = String.fromCharCode(bytes[8], bytes[9], bytes[10], bytes[11]);
                if (brand === 'M4A ' || brand === 'M4B ') {
                    return returnExtension ? 'm4a' : "Audio";
                }
                return returnExtension ? 'mp4' : "Video";
            }

            // glTF binary format
            if (asciiAt(0, 'glTF')) {
                return returnExtension ? 'glb' : "3d";
            }

            // Other signatures
            const signatures = [
                { type: 'image/png', hex: '89504e47', ext: 'png' },
                { type: 'image/jpeg', hex: 'ffd8ff', ext: 'jpg' },
                { type: 'video/webm', hex: '1a45dfa3', ext: 'webm' },
                { type: 'audio/ogg', hex: '4f676753', ext: 'ogg' },
                { type: 'application/pdf', hex: '25504446', ext: 'pdf' },
            ];

            const matched = signatures.find(sig => hex.startsWith(sig.hex.toLowerCase()));
            if (matched) {
                if (returnExtension) return matched.ext;
                const mimeType = matched.type;
                if (mimeType.startsWith("image/")) return "Image";
                if (mimeType.startsWith("video/")) return "Video";
                if (mimeType.startsWith("audio/")) return "Audio";
                return mimeType;
            }

            console.log(`getMediaType: Unknown media type, hex: ${hex.substring(0, 32)}`);
            return returnExtension ? 'unknown' : "Unknown";
        } catch (err) {
            console.error("Error parsing base64:", err);
            return returnExtension ? 'invalid' : "Invalid Base64 String";
        }
    }

    /**
     * Tries to grab the collection image with the given uid
     * @returns {Promise<*>}
     */
    const getSpecificImage = async (uid) => {
      return await db.collection
          .where('uid')
          .equals(uid)
          .first();
  }

    const toggleCollection = async () => {
      console.log(`VIDEO - toggleCollection`);
        
        if (accountContext.loggedIn === false) {
            Swal.fire({
                title: "Not Logged In",
                text: "You need to be logged in to add images to your collection. Please login to your account to proceed.",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFB02E",
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/profile')
                }
            })
            return;          
        }

        // Set the toggle lock
        await db.settings.put({ key: 'toggleLock', value: true });

        // Pre-loading Sound File and setting check
        const collectAudio = new Audio(CollectSound);
        const soundSettingCheck = await db.settings.where('key').equals('play_sounds').first()

        try{
        const inCollection = !props.inCollection;

        let inPlayground = false;
        let propsId = props.id;
        await db.images.where('image').equals(props.image).toArray(async(images) => {
            if (images.length > 0) {
                propsId = images[0].id;
                inPlayground = true;
            }
        });

        await db.images
            .update(propsId, {inCollection})
            .then(async () => {
                await db.collectedImages.where('hash').equals(props.hash).count(async(imageCount) => {
                    if (imageCount > 0) {
                        // removing the image from the collection
                        if (!inCollection) {
                            if (!inPlayground) {
                                await db.collectedImages.where('image').equals(props.image).toArray(async(collectedImage) => {
                                    if (collectedImage.length > 0) {
                                        console.log("Adding image to playground");
                                        // THIS SHOULD BE IN THE SAME FORMAT AS getPromptFileData
                                        await getImageMetadata(accountContext.accountDetails.accountNo, collectedImage[0].hash)
                                            .then((prompt) => {
                                                db.collection.put({
                                                    uid: collectedImage[0].uid,
                                                    prompt : prompt.prompt,
                                                    queue:  'RC' + (Math.random() + 1).toString(36).substring(2).toUpperCase(),// We don't have this value as it wasn't created in this playground - create a dummy value
                                                    timestamp: Date.now(),
                                                });
                                            })
                                            .finally(() => {
                                                console.log("Added image history to local db");
                                            })

                                        await db.images.put({
                                           image : collectedImage[0].image,
                                           seed: collectedImage[0].seed,
                                           uid: collectedImage[0].uid,
                                           model: collectedImage[0].model,
                                           inCollection: false,
                                           hash: collectedImage[0].hash,
                                           online: collectedImage[0].online,
                                            tag: collectedImage[0].tag
                                       });
                                    }
                                });
                            }


                            db.collectedImages.where('image').equals(props.image).delete();
                            console.log("Removing image from collection DB");
                            deleteCollectionImage(accountContext.accountDetails.accountNo, props.hash)
                            props.refreshImages()
                        }
                    } else {
                        // adding the image to the collection
                        let iCount
                        await db.collectedImages.count((collectedCount) => {
                            iCount = collectedCount + 1;
                        })
                        console.log("Adding image to collection DB: ", iCount);
                        console.log(props);

                        // db.collectedImages.put({uid: props.uid, imageID: iCount, image: props.image, seed: props.seed, model: props.model, hash: props.hash, online: props.online, tag: props.tag, prompt:promptInfo.prompt, public: false, dataType: props.dataType, timestamp: Date.now()})

                        getSpecificImage(props.uid).then(async(image) => {
                            // let fileExt = ''

                            // if (!props.image.includes('://') || !props.image.includes(':\\') || !props.image.includes('http')) {
                            //     fileExt = await getMediaType(props.image, false)
                            // }

                            let imageArr = [{
                                uid: props.uid,
                                image: props.image,
                                seed: props.seed,
                                model: props.model,
                                hash: props.hash,
                                online: props.online,
                                tag: props.tag,
                                prompt:promptInfo.prompt,
                                dataType: "glb"
                            }]
                            let colArr = null
                            if (image) {
                                colArr = JSON.stringify([image])
                            }
                            console.log("Going through the update API call: ", imageArr, " | ", colArr);
                            if (electronBridge.isElectron && props.image.includes('://') || props.image.includes(':\\')) {
                                const tokens = getAuthorizationToken();
                                const devAPI = await getUseDepApi();
                                
                                const response = electronBridge.ipcRenderer.invoke('collection_upload', JSON.stringify(imageArr), accountContext.accountDetails.accountNo, null, colArr, tokens, devAPI);
                                console.log('Collecion Upload Response: ', response);
                                
                            } else {
                                updateAccount(JSON.stringify(imageArr), accountContext.accountDetails.accountNo, null, colArr)
                            }
                        });
                    }
                });
                // props.refreshImages();
            }).then(async () => {
                setLocalInCollection(!localInCollection);
                if (soundSettingCheck.value && inCollection) {
                    // const collectAudio = new Audio(CollectSound);
                    collectAudio.loop = false;
                    collectAudio.volume = 0.8;
                    collectAudio.play();
                }
            });
        // Add a delay to ensure API processing
        await new Promise(resolve => setTimeout(resolve, 2000));
      } finally {
          // Release the toggle lock
          await db.settings.put({ key: 'toggleLock', value: false });
      }
    }

    const handleDescribeImage = async() => {
      console.log("Describe the image")

      setOpenDescribeImage(true)
      setImageDescription("Generating ...");
      setImageDescriptionLoading(true);

      let imageDescription = "";
      const item = await db.imageDescriptions.where('hash').equals(props.hash).first();

      if (item) {
          console.log("Pulling description from local db")
          imageDescription = item.description
          setImageDescription(imageDescription);
      } else {
          console.log("Pulling description from api")

          let imageDescription ;
          
          if (props.inCollection) {
              imageDescription = getImageDescription(accountContext.accountDetails.accountNo, props.hash, "")
          } else {
              imageDescription = getImageDescription(accountContext.accountDetails.accountNo, "", props.image)
          }
          
          imageDescription.then((description) => {
              console.log(description)
              if (description.image_description !== undefined) {
                  imageDescription = description.image_description;

                  if (imageDescription.length > 0) {
                      setImageDescription(imageDescription);
                      setImageDescriptionLoading(false);
                      db.imageDescriptions.put({
                          hash: props.hash,
                          description: imageDescription,
                          timestamp: Date.now()
                      });
                  }
              }
          });
      }
    }

    const handlePromptPopulation = () => {
      populatePromptField(imageDescription, updatePrompt)
      setOpenDescribeImage(false)
    }

    const handlePrivatePublic = async() => {
        if (accountContext.accountDetails.alias !== "") {
            setPrivateImage(!privateImage);
            if (!privateImage) {
                setVisibility("Private")
                console.log('Entire props during handle private public: ', props)
                console.log("Changing Image Visibility Route: ", props.hash);
                await changeImageVisibility(accountContext.accountDetails.accountNo, props.hash, 0)
                .then(() => {
                    console.log("Image Visibility Changed Successfully");
                })
                .catch((e) => {
                    console.log("Image Visibility did not change");
                    setVisibility("Public")
                    setPrivateImage(!privateImage);
                })
                // await props.dbTable.update(props.id, {uid: props.uid, image: props.image, seed: props.seed, model: props.model, hash: props.hash, online: props.online, tag: props.tag, prompt:promptInfo.prompt, public: false}).then(async(updated) => {
                //     if (updated) {
                //         setVisibility("Private")
                //         console.log("Changing Image Visibility Route: ", props.hash);
                //         await changeImageVisibility(accountContext.accountDetails.accountNo, props.hash, 0)
                //         .then(() => {
                //             console.log("Image Visibility Changed Successfully");
                //         })
                //         .catch((e) => {
                //             console.log("Image Visibility did not change");
                //             setVisibility("Public")
                //             setPrivateImage(!privateImage);
                //         })
                //         // props.refreshImages();
                //     }
                // })
            } else {
                setVisibility("Public")
                console.log("Changing Image Visibility Route: ", props.hash);
                await changeImageVisibility(accountContext.accountDetails.accountNo, props.hash, 1)
                .then(() => {
                    console.log("Image Visibility Changed Successfully");
                })
                .catch((e) => {
                    console.log("Image Visibility did not change");
                    setVisibility("Private")
                    setPrivateImage(!privateImage);
                })
                // await props.dbTable.update(props.id, {uid: props.uid, image: props.image, seed: props.seed, model: props.model, hash: props.hash, online: props.online, tag: props.tag, prompt:promptInfo.prompt, public: true}).then(async(updated) => {
                //     if (updated) {
                //         setVisibility("Public")
                //         console.log("Changing Image Visibility Route: ", props.hash);
                //         await changeImageVisibility(accountContext.accountDetails.accountNo, props.hash, 1)
                //         .then(() => {
                //             console.log("Image Visibility Changed Successfully");
                //         })
                //         .catch((e) => {
                //             console.log("Image Visibility did not change");
                //             setVisibility("Private")
                //             setPrivateImage(!privateImage);
                //         })
                //         // props.refreshImages();
                //     }
                // })
            }
        } else {
            Swal.fire({
                title: "No Username",
                text: "You need to have an username in order to make your images available to the public. Please login in to the website and set yourself a username before proceeding.",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFB02E",
            }).then((result) => {
                if (result.isConfirmed) {
                    window.open("https://login.promptus.ai/account", "_blank")
                }
            })
        }
    }

    const editTagOnImage = () => {
      setTagLoading(true);
      let multiOptions = "";
      let initTag
      let concate

      setTimeout(() => {
          if (isUndefined(props.tag) == false) {
              if (clearTags == false) {
                  initTag = props.tag + ","
              } else {
                  initTag = "";
              }
          } else {
              initTag = "";
          }

          console.log(`Init Tag: ${initTag}`);

          if (selectedOptions !== "" && !selectedOptions.includes("undefined")) {
              selectedOptions.map((arrValue) => {

                  if (!initTag.includes(arrValue.value) || clearTags == true){
                      console.log(`Adding Tag: ${arrValue.value}`);
                      multiOptions += arrValue.value + ",";
                  }
              })
              initTag += multiOptions;
          }


      }, 1000)

      setTimeout(() => {
          if (inputTag !== "") {
              if (!initTag.includes(inputTag)){
                  concate = initTag + inputTag
              } else {
                  concate = initTag
              }
          } else {
              concate = initTag;
          }   

          console.log(`Init Tag: ${initTag}`);
          console.log(`Input Tag: ${inputTag}`);

          if (concate.endsWith(',')) {
              concate = concate.slice(0, -1);
          }
          if (concate.startsWith(',')) {
              concate = concate.substring(1);
          }
          if (concate == '') {
              Swal.fire({
                  color: "#190A4E",
                  title: "Tag Empty",
                  text: "You cannot tag an image with an empty tag. Please add a tag to the image before proceeding.",
                  icon: "info",
                  timer: 2000,
                  timerProgressBar: true,
                  showConfirmButton: false
              })
              setTagLoading(false);
              return;
          }  
          setTag(concate)

          console.log(`Concatenated Tag: ${concate}`);
          
          props.dbTable.update(props.id, {tag: concate}).then(async(updated) => {
              if (updated) {
                  if (props.isMyCollection) {
                      // Update the tag in the images table if it exists
                      let generatedImages = [];
                      await db.images.reverse().toArray((images) => {
                          generatedImages = images;
                      });
                      let imageInImagesTable;
                      generatedImages.forEach((image) => {
                          if (image.hash === props.hash) {
                              imageInImagesTable = image;
                          }
                      })
                      if (imageInImagesTable) {
                          db.images.update(imageInImagesTable.id, { tag: concate });
                      } else {
                          console.log("Image not found in the images table");
                      }
                      console.log("Update Image Tags Route: ", props.hash);
                      updateImageTags(accountContext.accountDetails.accountNo, props.hash, concate)

                  } else {
                      let collectionImages = [];
                      await db.collectedImages.reverse().toArray((images) => {
                          collectionImages = images;
                      });
                      let imageInCollectionTable;
                      collectionImages.forEach((image) => {
                          if (image.hash === props.hash) {
                              imageInCollectionTable = image;
                          }
                      })
                      if (imageInCollectionTable) {
                          db.collectedImages.update(imageInCollectionTable.id, { tag: concate });
                      } else {
                          console.log("Image not found in the collection table");
                      }
                  }
                  Swal.fire({
                      title:"Success",
                      text:"Your image was successfully tagged",
                      icon:"success",
                      timer: 1000,
                      showConfirmButton: false
                  }).then(() => {
                      setTagLoading(false);
                      setInputTag("");
                      setClearTags(false);
                      setSelectedOptions([]);
                      props.refreshTags();
                      if (!props.isMyCollection) {
                          props.refreshImages();
                      }
                      // props.refreshImages();
                  })
                  setOpen(false)
              }
          })

      }, 2500)

    }

    const handleClearTag = () => {
      setClearTags(!clearTags);
    }

    const shareMediaAction = async (platform) => {
        const loadingPopup = Swal.fire({
            title: 'Processing',
            html: 'Preparing to share...',
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            if (accountContext.loggedIn === false) {
                loadingPopup.close();
                Swal.fire({
                    title: "Not Logged In",
                    text: "You need to be logged in to share. Please login to your account to proceed.",
                    icon: "error",
                    confirmButtonText: "Ok",
                    confirmButtonColor: "#FFB02E",
                }).then((result) => {
                    if (result.isConfirmed) {
                        navigate('/profile')
                    }
                });
                return;
            }

            await db.settings.put({ key: 'toggleLock', value: true });

            try {
                Swal.update({ html: 'Uploading 3D model for sharing...' });

                const collectionImage = await getSpecificImage(props.uid);
                const colArr = collectionImage ? [collectionImage] : null;

                let imageArr = [{
                    uid: props.uid,
                    image: props.image,
                    seed: props.seed,
                    model: props.model,
                    hash: props.hash,
                    online: props.online,
                    tag: props.tag,
                    prompt: promptInfo.prompt,
                }];

                let uploadResult;
                if (electronBridge.isElectron && props.image && props.image.includes(':\\')) {
                    const tokens = getAuthorizationToken();
                    const devAPI = await getUseDepApi();
                    uploadResult = await electronBridge.ipcRenderer.invoke('collection_upload', JSON.stringify(imageArr), accountContext.accountDetails.accountNo, null, colArr, tokens, devAPI);
                } else {
                    uploadResult = await updateAccount(JSON.stringify(imageArr), accountContext.accountDetails.accountNo, null, colArr);
                }

                if (!uploadResult?.url) {
                    throw new Error('Failed to get share URL from upload');
                }

                const shareUrl = uploadResult.url;

                Swal.update({ html: 'Opening share dialog...' });

                const shareConfig = {
                    twitter: {
                        width: 550,
                        height: 420,
                        baseUrl: 'https://twitter.com/intent/tweet',
                        title: 'Share on Twitter'
                    },
                    facebook: {
                        width: 626,
                        height: 436,
                        baseUrl: 'https://www.facebook.com/sharer/sharer.php',
                        title: 'Share on Facebook'
                    }
                };

                if (!(platform in shareConfig)) {
                    throw new Error(`Unsupported platform: ${platform}`);
                }

                const shareContent = {
                    url: shareUrl,
                    text: `Check out this AI-generated 3D model on Promptus!`,
                    hashtags: 'AI,Promptus,AI3D',
                    via: 'promptus_ai'
                };

                const config = shareConfig[platform];
                let shareWindowUrl = platform === 'twitter'
                    ? `${config.baseUrl}?text=${encodeURIComponent(shareContent.text)}&url=${encodeURIComponent(shareContent.url)}&hashtags=${encodeURIComponent(shareContent.hashtags)}&via=${shareContent.via}`
                    : `${config.baseUrl}?u=${encodeURIComponent(shareContent.url)}`;

                const windowFeatures = {
                    width: config.width,
                    height: config.height,
                    left: (window.screen.width / 2) - (config.width / 2),
                    top: (window.screen.height / 2) - (config.height / 2)
                };

                const windowFeaturesString = Object.entries(windowFeatures)
                    .map(([key, value]) => `${key}=${value}`)
                    .join(',');

                if (electronBridge.isElectron) {
                    electronBridge.ipcRenderer.send('open-urlInExternal', shareWindowUrl);
                } else {
                    const shareWindow = window.open(
                        shareWindowUrl,
                        config.title,
                        windowFeaturesString
                    );

                    if (!shareWindow) {
                        throw new Error('Popup was blocked');
                    }
                }

                loadingPopup.close();
            } finally {
                await db.settings.put({ key: 'toggleLock', value: false });
            }

        } catch (error) {
            console.error('Error in shareMediaAction:', error);
            loadingPopup.close();
            Swal.fire({
                title: "Error",
                html: error.message === 'Popup was blocked'
                    ? "<p>Please allow popups to share this content</p>"
                    : "<p>Sorry, there was an error sharing the 3D model. Please try again.</p>",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFB02E",
            });

            try {
                await db.settings.put({ key: 'toggleLock', value: false });
            } catch (lockError) {
                console.error('Error releasing lock:', lockError);
            }
        }
    };

    const handleTagging = () => {
      setOptions([]);

      const combinedTags = [...collectionContext.tags, ...collectionContext.collectionTags];
      const uniqueTags = [...new Set(combinedTags)];

      const sortedTags = uniqueTags.sort((a, b) => a.localeCompare(b));
      setOptions(sortedTags.map(tag => ({ value: tag, label: tag })));
      setOpen(true)
    }

    const handleEnter = (e) => {
      if (e.key === "Enter") {
          editTagOnImage();
      }
    }

    const viewDetails = async (e) => {
        if (e) {
            e.stopPropagation();
        }

        if (!props.viewFailedImage) {
            return;
        }

        const modelDetails = await db.collection.where('uid').equals(props.uid).toArray();
        if (modelDetails.length > 0) {
            let prompt = modelDetails[0].prompt;
            const details = prompt.prompt || prompt;
            props.viewFailedImage({
                ...details,
                id: props.id,
                uid: props.uid,
                hash: props.hash,
                jobUid: modelDetails[0].uid
            });
        } else {
            props.viewFailedImage({
                id: props.id,
                uid: props.uid,
                hash: props.hash,
                image: props.image
            });
        }
    };

    const deleteImage = async () => {
      let imageNotFound = false;
      if (props.isMyCollection) {
          db.collectedImages
              .where("image")
              .equals(props.image)
              .delete()
              .then(async () => {
                  console.log("check if video is in generated videos and remove the flag");
                  // check if image is in generated images and remove the flag
                  await db.images.where('image').equals(props.image).toArray(async(images) => {
                      if (images.length > 0) {
                          // removing the image from the collection
                          db.images.update(images[0].id, {inCollection: false})
                          console.log("Removing image from collection");
                          Swal.fire({
                              color: "#190A4E",
                              title: "Confirm Delete",
                              text: `Are you sure you want to delete this image from your ${props.isMyCollection ? "Collection" : "Playground"}?`,
                              icon: "info",
                              confirmButtonText: 'Yes',
                              confirmButtonColor: "#FFB02E",
                              showDenyButton: true,
                              denyButtonText: "No",
                              denyButtonColor: "#190A4E",
                          }).then((result) => {
                              if (result.isConfirmed) {
                                  deleteCollectionImage(accountContext.accountDetails.accountNo, images[0].hash)
                                  .then((data) => props.refreshImages())
                              }
                          })
                      } else {
                          imageNotFound = true;
                      }
                  });
                  if (imageNotFound) {
                      Swal.fire({
                          color: "#190A4E",
                          title: "Confirm Delete",
                          text: `Are you sure you want to delete this video from your ${props.isMyCollection ? "Collection" : "Playground"}?`,
                          icon: "info",
                          confirmButtonText: 'Yes',
                          confirmButtonColor: "#FFB02E",
                          showDenyButton: true,
                          denyButtonText: "No",
                          denyButtonColor: "#190A4E",
                      }).then((result) => {
                          if (result.isConfirmed) {
                              deleteCollectionImage(accountContext.accountDetails.accountNo, props.hash)
                              .then((data) => props.refreshImages())
                          }
                      })
                  }
              });
          return;
      }
      Swal.fire({
          color: "#190A4E",
          title: "Confirm Delete",
          text: `Are you sure you want to delete this video from your ${props.isMyCollection ? "Collection" : "Playground"}?`,
          icon: "info",
          confirmButtonText: 'Yes',
          confirmButtonColor: "#FFB02E",
          showDenyButton: true,
          denyButtonText: "No",
          denyButtonColor: "#190A4E",
      }).then((result) => {
          if (result.isConfirmed) {
              db.images
              .where("id")
              .equals(props.id)
              .delete()
              .then(props.refreshImages);
          }
      })

    }

    const handleMouseEnter = async () => {
        if (videoRef.current && videoRef.current.paused) {
          try {
            // Set muted state based on auto sound setting
            videoRef.current.muted = !enableAutoSound;
            await videoRef.current.play();
          } catch (error) {
            // Ignore interruption errors
            if (error.name !== 'AbortError') {
              console.error('Video play error:', error);
            }
          }
        }

        setShowVideoControls(true);
      };
    
      const handleMouseLeave = () => {
        if (videoRef.current && !videoRef.current.paused) {
          try {
            videoRef.current.pause();
          } catch (error) {
            console.error('Video pause error:', error);
          }
        //   videoRef.current.currentTime = 0; // Reset to the beginning if needed
        }

        setShowVideoControls(false);
      };

      const getBlobFromSource = async (source, contentType) => {
        if (!source) {
          throw new Error("No source provided");
        }
      
        // 1) If it looks like a URL (http, https, /, blob:) or a local file path
        const looksLikeUrl =
          source.startsWith("http://") ||
          source.startsWith("https://") ||
          source.startsWith("/") ||
          source.startsWith("blob:") ||
          /^[a-zA-Z]:\\/.test(source);
      
        if (looksLikeUrl) {
          // Fetch the file from the URL
          const response = await fetch(source);
          if (!response.ok) {
            throw new Error("Failed to fetch file: " + response.status);
          }
          // Let the browser decide contentType from the response,
          // or override if you really want
          const blob = await response.blob();
          if (contentType) {
            return blob.slice(0, blob.size, contentType);
          }
          return blob;
        }
      
        // 2) Otherwise assume it's base64
      
        // If it's a data URL like "data:image/png;base64,AAAA..."
        const base64Part = source.includes(",") ? source.split(",")[1] : source;
      
        return base64toBlob(base64Part, contentType);
      };

    const base64toBlob = (b64Data, contentType='', sliceSize=512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }

    const downloadModel = async (contentType, ext) => {
        const blobFile = await getBlobFromSource(props.image, contentType);

        if (window.showSaveFilePicker) {
            try {
                const handle = await window.showSaveFilePicker({
                    suggestedName: `${downloadName}.${ext}`,
                    types: [{ description: `${ext.toUpperCase()} 3D Model`, accept: { [contentType]: [`.${ext}`] } }]
                });
                const writable = await handle.createWritable();
                await writable.write(blobFile);
                await writable.close();
                return;
            } catch (err) {
                if (err.name === 'AbortError') return;
                console.warn('showSaveFilePicker failed, falling back:', err);
            }
        }

        const blobUrl = URL.createObjectURL(blobFile);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = `${downloadName}.${ext}`;
        document.body.appendChild(link);
        link.dispatchEvent(new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        }));
        document.body.removeChild(link);
    };

    //   const downloadVideo = (contentType, ext) => {
    //     // https://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
        
    //     const blobFile = base64toBlob(props.image, contentType);
    //     const blobUrl = URL.createObjectURL(blobFile);
    //     const link = document.createElement("a");
    //     link.href = blobUrl;
    //     link.download = `${downloadName}.${ext}`;
    //     document.body.appendChild(link);
    //     link.dispatchEvent(new MouseEvent('click', {
    //         bubbles: true,
    //         cancelable: true,
    //         view: window
    //     }));
    //     document.body.removeChild(link);
    // };

    const downloadPrompt = async () => {
        console.log("DOWNLOADING PROMPT")
        const item = await db.collection.where('uid').equals(props.uid).first();

        if (item) {
            downloadString(JSON.stringify(item), 'application/json', `${downloadName}.prompt`);
        } else {
            // THIS SHOULD BE IN THE SAME FORMAT AS getImageMetadata
            getPromptFileData(accountContext.accountDetails.accountNo, props.uid).then((prompt) => {
                console.log(prompt)
                db.collection.put({
                    uid: prompt.uid,
                    prompt : prompt,
                    queue:  'RC' + (Math.random() + 1).toString(36).substring(2).toUpperCase(),// We don't have this value as it wasn't created in this playground - create a dummy value
                    timestamp: Date.now(),
                });
                downloadString(JSON.stringify(prompt), 'application/json', `${downloadName}.prompt`);
            });
        }

    }

        // Handle opening file in explorer
        const handleViewInExplorer = async () => {
            try {
                if (!electronBridge.isElectron) {
                    console.warn('View in explorer is only available in the desktop app');
                    return;
                }
                
                // Check if image is a file path
                if (props.image && (props.image.includes(':\\') || props.image.includes('://'))) {
                    console.log('Opening file location:', props.image);
                    
                    // Clean up the file path (remove file:// prefix if present)
                    let filePath = props.image;
                    if (filePath.startsWith('file://')) {
                        filePath = filePath.replace('file:///', '').replace('file://', '');
                        // Handle URL encoded characters if any
                        filePath = decodeURIComponent(filePath);
                    }
                    
                    // Use IPC to request main process to open and focus the explorer
                    // This allows the main process to use additional APIs for focusing
                    if (electronBridge.ipcRenderer) {
                        electronBridge.ipcRenderer.invoke('show-item-in-folder', filePath);
                    } else {
                        // Fallback to direct shell module if IPC not available
                        const { shell } = window.require('electron');
                        shell.showItemInFolder(filePath);
                        
                        // Try to bring focus using exec command on Windows
                        const { exec } = window.require('child_process');
                        const path = window.require('path');
                        
                        // On Windows, use explorer with /select flag which should bring focus
                        if (process.platform === 'win32') {
                            const normalizedPath = path.normalize(filePath);
                            exec(`explorer.exe /select,"${normalizedPath}"`, (error) => {
                                if (error) {
                                    console.error('Error focusing explorer:', error);
                                }
                            });
                        }
                    }
                }
            } catch (error) {
                console.error('Error opening file in explorer:', error);
                Swal.fire({
                    title: "Error",
                    text: "Unable to open file location",
                    icon: "error",
                    confirmButtonText: "Ok",
                    confirmButtonColor: "#FFB02E",
                });
            }
        };

      // Determine video source - handle both URLs and base64 data
      let videoSrc;
      if (electronBridge.isElectron && props.image && props.image.includes(":\\")) {
          // Electron environment and file path (Windows or Unix)
          videoSrc = toFileUrl(props.image);
      } else if (props.image && props.image.startsWith('http')) {
          // Remote URL
          videoSrc = props.image;
      } else if (props.image) {
          // Assume base64
          videoSrc = `data:video/mp4;base64,${props.image}`;
      }

    const getBorderColor = () => {
        if (props.uid?.toLowerCase().includes("momm")) {
            return 'border-green-500';
        }

        switch (props.serverType) {
            case 'gpu':
            case 'cpu':
                return 'border-white';
            case 'cosy':
                return 'border-cyan';
            case 'online':
            default:
                return props.online === false ? 'border-white' : 'border-amber-500';
        }
    };

    const borderColor = getBorderColor();

      return (
        <>
          <div className="group relative w-fit h-full mx-auto">
            {/* Mobile Menu Button - Always visible on mobile */}
            {isMobile && !props.hideToolbar && (
                <button
                    ref={menuButtonRef}
                    onClick={() => setShowMobileToolbar(!showMobileToolbar)}
                    className="absolute top-2 right-2 z-20 bg-dark-blue/80 backdrop-blur p-2 rounded-lg shadow-lg"
                    title="Show options"
                >
                    <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                    </svg>
                </button>
            )}
            
            {/* Toolbar - Desktop: hover, Mobile: click toggle */}
            {!props.hideToolbar && (
            <div
                ref={toolbarRef}
                className={`${
                    isMobile
                        ? (showMobileToolbar ? 'visible opacity-100' : 'invisible opacity-0')
                        : 'invisible group-hover:visible opacity-0 group-hover:opacity-100'
                } transition-all duration-200 absolute -top-5 z-10 left-0 right-0`}>
              <div className="bg-dark-blue/90 backdrop-blur flex flex-row flex-wrap justify-center self-center p-2 rounded gap-2 shadow-lg w-full">
                {/* Toolbar content placeholder */}
                <div className="h-8 w-full flex items-center justify-center text-white font-semibold">
                  {!props.isMyCollection ?
                                <button className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={toggleCollection} title={`${props.inCollection ? "Remove from Collection" : "Add to Collection"}`}>
                                    {localInCollection ?
                                        <img src={cardInCollection} alt={"In Collection Icon"} className="w-5 h-5"/> 
                                    :
                                        <img src={cardAdd} alt={"Add to Collection Icon"} className="w-5 h-5"/>
                                    }
                                </button> :
                                <>
                                    <button className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={toggleCollection} title="Remove from Collection">
                                        <img src={cardInCollection} alt={"In Collection Icon"} className="w-5 h-5"/>
                                    </button>
    
                                    <button title={`${privateImage ? 'Make the video public': 'Make the video private'}`} className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} 
                                    onClick={handlePrivatePublic}
                                    >
                                    {privateImage ?
                                        <img src={cardPrivate} alt="Private Icon" className="w-5 h-5"/> 
                                    :
                                        <img src={cardPublic} alt="Public Icon" className="w-5 h-5"/>
                                    }
                                    </button>
                                </>
                            }
                  {/* <button title="Describe Image" className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={handleDescribeImage}>
                                <img src={cardImageDescribe} alt={"Describe Icon"} className="w-5 h-5"/>
                            </button>           */}
                  <button title="Share 3D Model" className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"}
                          onClick={() => setShowShareDialog(!showShareDialog)}>
                      <CardShare alt="Share Icon" className="w-5 h-5"/>
                  </button>
                  <button title="Save 3D Model" className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={() => setShowSaveDialog(!showSaveDialog)}>
                    <CardSave alt={"Save Icon"} className="w-5 h-5"/>
                </button>
                  <button title="Tag 3D Model" className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={handleTagging}>
                      <img src={cardTag} alt={"Tag Icon"} className="w-5 h-5"/>
                  </button>   
                  <button title="Delete 3D Model" className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={deleteImage}>
                      <img src={cardRemove} alt={"Remove Icon"} className="w-5 h-5c"/>
                  </button>
                  {props.viewFailedImage && (
                      <button title="View Details" className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={viewDetails}>
                          <CardEye alt={"View Details Icon"} className="w-5 h-5"/>
                      </button>
                  )}
                </div>
                {showSaveDialog ?
                    <div className="w-full flex flex-col gap-2 bg-dark-blue/90 backdrop-blur p-2 rounded-b">
                        <input type={"text"} className={"w-full rounded text-dark-blue p-2 text-sm"}
                            onChange={(e) => setDownloadName(e.target.value)} value={downloadName}
                            onFocus={(e) => e.target.select()}
                        />
                        <div className="w-full flex flex-row justify-center gap-4">
                            <button className="bg-dark-blue/40 rounded-lg px-4 py-2 hover:bg-dark-blue transition" onClick={() => downloadModel('model/gltf-binary', 'glb')}>.glb</button>
                            <button className="bg-dark-blue/40 rounded-lg px-4 py-2 hover:bg-dark-blue transition" onClick={downloadPrompt}>.prompt</button>
                        </div>
                    </div>
                    : null
                }
                {showShareDialog ?
                    <div className={"flex flex-row justify-center gap-4 p-2 bg-dark-blue/90 backdrop-blur rounded-b"}>
                        <button className={"bg-dark-blue/40 rounded-lg px-4 py-2 hover:bg-dark-blue transition"} onClick={() => shareMediaAction('facebook')}>Facebook</button>
                        <button className={"bg-dark-blue/40 rounded-lg px-4 py-2 hover:bg-dark-blue transition"} onClick={() => shareMediaAction('twitter')}>Twitter</button>
                    </div>
                    : null
                }
              </div>
            </div>
            )}
            {/* Model Container */}
            <div className={`${props.className ? `${props.className} rounded-xl overflow-hidden relative border-4 ${borderColor} bg-black` : `w-full h-full rounded-xl overflow-hidden relative border-4 ${borderColor} bg-black`}`}>
            <model-viewer
                src={localModelOverride || props.image}
                alt="PromptusAI generated 3D model"
                camera-controls
                auto-rotate
                exposure="1"
                class="w-full h-full"
            />
              {props.isMyCollection ?
                        <div className={`absolute group-hover:hidden top-0 left-0 rounded px-3 py-2 bg-dark-blue text-base`}>{visibility}</div>
                    :
                        null    
                    }
                    {props.model ?
                        <div className={`absolute group-hover:hidden top-0 right-0 rounded px-3 py-2 bg-dark-blue/60 text-base`}>{props.model}</div>
                    :
                        null
                    }
              {tag ? 
                        <div className={`absolute group-hover:hidden bottom-0 left-0 rounded px-3 py-2 bg-dark-blue/40 text-sm`}>{tag}</div>
                    :
                        null
                    }
            </div>
            <Modal open={open} onClose={() => setOpen(false)} center container={document.querySelector('.main-content')}>
                            <h2 className="text-2xl mb-5 font-bold">Category</h2>
                            <p>
                                Edit the tags you would like to add with the image
                            </p>
                            <div className="flex flex-row items-center justify-between my-5">
                                <p className="place-content-start">Original Tag: <span className="font-bold">{tag}</span></p>
                                <div id="clearTags" className={"flex flex-row items-center place-content-end"}>
                                    <ToggleInput id={"clearTags"} onChange={() => handleClearTag()}/>
                                    <label htmlFor={"clearTags"}
                                            className={`inline-block ml-2 text-sm font-medium ${clearTags ? 'text-yellow' : 'text-dark-blue'} transition`}>Clear Tags?</label>
                                </div>
                            </div>
                            <div className={"p-5 my-5 border border-dark-blue rounded-lg"}>
                                <label className="block mb-2 text-sm font-medium" htmlFor="existing">Existing Category</label>
                                {/* <select name="existing" className={"rounded-lg text-dark-blue border border-dark-blue p-2 w-2/5"} value={tag} onChange={(e) => setTag(e.target.value)}>
                                    <option value={`${props.tag}`}>{props.tag}</option>
                                </select> */}
                                <Select options={options} components={animatedComponents} onChange={(e) => setSelectedOptions(e)} isMulti isClearable onKeyDown={(e) => handleEnter(e)}/>
                            </div>
                            <div className="flex flex-row items-center">
                                <hr className={"flex-grow border border-dark-blue/40 bg-dark-blue/40"} />
                                <h1 className="mx-4 font-bold text-xl">OR</h1>
                                <hr className={"flex-grow border border-dark-blue/40 bg-dark-blue/40"} />
                            </div>
                                <p>
                                    Type in a new category to have more ease in sorting your images
                                </p>
                                <div className={"p-5 my-5 border border-dark-blue rounded-lg"}>
                                    <label className="block mb-2 text-sm font-medium" htmlFor="emailAddress">New Category</label>
                                    <input type="text" name="emailAddress" className="w-full rounded-lg text-dark-blue border border-dark-blue p-2" placeholder="Category"
                                    value={inputTag} onChange={(e) => setInputTag(e.target.value)} onKeyDown={(e) => handleEnter(e)}/>
                                </div>
                            <div className="flex flex-row justify-center gap-4">
                                <button onClick={() => editTagOnImage()} className="rounded w-1/2 mx-auto mt-6 mb-3 p-2 bg-yellow text-dark-blue shadow font-bold">
                                    {tagLoading ?
                                            <svg aria-hidden="true" role="status" class="inline w-5 h-5 mr-3 mb-1 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffb02e"/>
                                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                                            </svg>
                                        :
                                            null
                                    }
                                    Categorize
                                </button>
                                <button onClick={() => setOpen(false)} className="rounded w-1/2 mx-auto mt-6 mb-3 p-2 bg-dark-blue text-yellow shadow font-bold">Cancel</button>
                            </div>
                        </Modal>  
          <Modal open={openDescribeImage} onClose={() => setOpenDescribeImage(false)} center container={document.querySelector('.main-content')}>
                            <h2 className="text-2xl mb-5 font-bold">Image Description</h2>
                            <p style={{minWidth: '600px'}}>
                                {imageDescriptionLoading ? 
                                    <svg aria-hidden="true" role="status" class="inline w-5 h-5 mr-3 mb-1 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffffff"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                                </svg> 
                                : 
                                    null
                                }
                                {/*
                                <div className="dot-container">
                                    <span className="text">Generating</span>
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                </div>
                                */}
                                {imageDescription}
                            </p>
                            <br></br>
                            <div>
                                <button className="me-3" title="Copy Description To Clipboard" onClick={() => copyDescriptionToClipboard(imageDescription, setClipboardMessage)}>
                                    <img src={cardCopyDescription} alt={"Copy Description To Clipboard Icon"}/>
                                </button>
                                <button className="me-3" title="Save As Prompt"
                                        onClick={() => downloadDescriptionAsPromptFile(imageDescription, downloadName)}>
                                    <img src={cardSaveDescription} alt={"Save As Prompt Icon"}/>
                                </button>
                                <button className="me-3" title="Populate Prompt" onClick={() => handlePromptPopulation()}>
                                    <img src={cardPopulatePrompt} alt={"Populate Prompt Icon"}/>
                                </button>
                                <span>{clipboardMessage}</span>
                            </div>
                        </Modal>
          </div>
        </>
    )
}